import React, { Component } from 'react';
import { withGoogleMap, GoogleMap, Marker, DirectionsRenderer, InfoWindow } from "react-google-maps"
import TaxiIcon from '../../img/taxiUbicacion1.png'
import PointP from '../../img/pointP.png'

const google = window.google;
const Taxi = { url: TaxiIcon, scaledSize: new google.maps.Size(30, 35) };
const pointP = { url: PointP, scaledSize: new google.maps.Size(20, 20) };
class MapaModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pasado:0
    }
  }

  onToggleOpenVC = (index) =>{
    let { pasado } = this.state;
    let id3 = 'emple'+index;
    if(id3 !== pasado ){
      this.setState({[id3]:!this.state[id3], [pasado]:false, pasado:id3 });
    }
    else{
      this.setState({[id3]:!this.state[id3], pasado:id3 });
    }
}

  render() {
    let { direccion, color, visible, coordE, isMulti, markers } = this.props;
    let lat = coordE.lat, lng = coordE.lng;

    return (
      <div>
        <GoogleMap
          ref='map'
          defaultZoom={14}
          center={{lat,lng}}>
          <Marker
            position={coordE}
            icon={Taxi}
          />
          {markers.map((snap,index) => {
            return (
              <Marker key={'keyM' + index} onClick={() => this.onToggleOpenVC(index)} icon={pointP} position={snap.location} >
                {
                  this.state['emple' + index] &&
                  <InfoWindow onCloseClick={() => this.onToggleOpenVC(index)}>
                    <div>
                      {' '}
                      {snap.name}
                    </div>
                  </InfoWindow>
                }
              </Marker>
            )
          })}

          {(visible !== false && !isMulti) &&
            <DirectionsRenderer options={{ polylineOptions: { strokeColor: color }, suppressMarkers: true }} directions={direccion} />
          }
          {(visible !== false && isMulti) &&
            <div>
              {direccion.map(snap => {
                return (
                  <DirectionsRenderer options={{ polylineOptions: { strokeColor: color }, suppressMarkers: true }} directions={snap} />
                )
              })}
            </div>
          }
        </GoogleMap>
      </div>
    )
  }
}
export default withGoogleMap(MapaModal);


// WEBPACK FOOTER //
// ./src/Components/perfilEmpleado/mapaModal.js